'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.invalidStyles = exports.validStyles = exports.formControl = exports.inputBorder = undefined;
var _polished = require('polished');
var _themes = require('@marmalade/themes');
var _componentThemes$form = _themes.componentThemes.form,
  controlStyle = _componentThemes$form.controlStyle,
  formTheme = _componentThemes$form.formTheme;
var inputBorder = exports.inputBorder = function inputBorder(theme) {
  return {
    borderWidth: theme.borderWidth,
    borderStyle: theme.borderStyle,
    borderColor: theme.borderColor,
    borderRadius: theme.borderRadius
  };
};
var formControl = exports.formControl = function formControl(theme) {
  return Object.assign({
    MozAppearance: 'none',
    WebkitAppearance: 'none',
    appearance: 'none',
    backgroundColor: formTheme(theme)[controlStyle('backgroundColor')]
  }, inputBorder(theme), {
    display: 'block',
    fontSize: theme.fontSize,
    fontWeight: theme.fontWeight,
    lineHeight: '1em',
    margin: 0,
    minHeight: '4.5rem',
    padding: '.6rem 1rem',
    position: 'relative',
    width: '100%',
    fontFamily: 'inherit'
  });
};
var validStyles = exports.validStyles = function validStyles(theme) {
  return {
    borderColor: theme.borderColorSuccess,
    color: theme.colorSuccessDark
  };
};
var invalidStyles = exports.invalidStyles = function invalidStyles(theme) {
  return {
    borderColor: theme.borderColorDanger,
    color: theme.colorDangerDark,
    backgroundColor: theme.colorDangerLightSolid,
    fontWeight: theme.invalidFontWeight
  };
};